<!----选择供应商分组弹窗------>
<template>
  <div>
    <div v-if="needSingle">
      <el-cascader
        ref="cascader"
        v-model="selectedSupplier"
        :options="supplierOptions"
        :show-all-levels="false"
        filterable
        :props="{
          checkStrictly: true,
          emitPath: false,
          label: 'name',
          value: 'categoryId'
        }"
        @change="changeSupplier"
      />
      <el-button
        v-if="selectedSupplier"
        type="text"
        style="padding: 0"
        @click="openSelectedSupplier"
      >
        查看已选供应商列表
      </el-button>
    </div>

    <div v-else style="display: inline-block">
      <el-button
        v-if="!readOnly"
        type="primary"
        size="mini"
        plain
        class="m-r-6"
        @click="openDrawer()"
      >
        <i class="el-icon-plus m-r-2"></i>
        添加
      </el-button>
      <el-button
        v-if="selectedRows.length"
        type="text"
        style="padding: 0"
        @click="openSelectedSupplier"
      >
        查看已选供应商列表
      </el-button>

      <div>
        <el-tag
          v-for="item in selectedRows"
          :key="item.categoryId"
          size="medium"
          effect="plain"
          type="info"
          class="m-b-4 m-r-6"
          :closable="!readOnly"
          @close="handleClose(item)"
        >
          {{ item.name }}
        </el-tag>
      </div>
      <!----- 选择公开范围 ---->
      <jczh-drawer
        class="drawer"
        :visible.sync="drawerVisible"
        title="选择公开范围"
        size="600px"
        :el-attrs="{
          destroyOnClose: true,
          wrapperClosable: false
        }"
        @close="handleDrawerClose"
        @confirm="handleConfirm"
      >
        <template slot="content">
          <div class="m-t-24">
            <el-input
              v-model="filterSupplierName"
              class="m-b-16"
              placeholder="请输入供应商分组名称"
              prefix-icon="el-icon-search"
              clearable
            />
            <el-tabs v-model="activeName" stretch>
              <el-tab-pane :label="supplierTitleList[0]" name="company">
                <el-tree
                  ref="companySupplierGroup"
                  :data="companySupplierList"
                  :props="{ label: 'name', children: 'children' }"
                  default-expand-all
                  :filter-node-method="filterNode"
                  highlight-current
                  check-strictly
                  node-key="categoryId"
                  show-checkbox
                  @check="clickNode"
                />
              </el-tab-pane>
              <el-tab-pane :label="supplierTitleList[1]" name="share">
                <el-tree
                  ref="sharedSupplierGroup"
                  :data="sharedSupplierList"
                  :props="{ label: 'name', children: 'children' }"
                  default-expand-all
                  :filter-node-method="filterNode"
                  highlight-current
                  check-strictly
                  node-key="categoryId"
                  show-checkbox
                  @check="clickNode"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>
      </jczh-drawer>
    </div>

    <!----- 已选择公司供应商列表 ------>
    <a-modal
      v-model="dialogVisible"
      title="已选供应商列表"
      :mask-closable="false"
      width="600px"
      :footer="null"
    >
      <jczh-table-content
        :data="selectedCompanyList"
        :option="companySupplierOptions"
        pagination
        :pagination-props="{
          layout: `prev, pager, next`
        }"
        :page.sync="page"
        :limit.sync="size"
        :total="total"
        @pagination="openSelectedSupplier()"
      />
    </a-modal>
  </div>
</template>
<script>
import {
  shareLibraryTypeDict,
  categoryTypeDict
} from '@/dictionary/supplier-management/supplier-lib'

import {
  getSupplierLibSortApi,
  getSupplierSharedCategoriesApi,
  getZjgjInquirySrmApi,
  getSelectedSupplierListApi
} from '@/api/supplier-management/supplier-lib'

import { listTransformTree } from '@/utils/utils'
import { difference, cloneDeep, isFunction, differenceBy } from 'lodash'

export default {
  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    selected: {
      type: Array,
      default: () => []
    },

    normalizeIn: {
      type: Function,
      default: list => list
    },

    normalizeOut: {
      type: Function,
      default: list => list
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    isSingle: {
      type: Boolean,
      default: false
    },

    isAgency: {
      type: Boolean,
      default: false
    },

    // 采购人公司id
    purchaseCompanyId: {
      type: [String, Number],
      default: ''
    },

    // 是否授权代理机构使用供应商库
    isAllowUseSrm: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      drawerVisible: false,

      filterSupplierName: '', // 筛选过滤供应商名称
      activeName: 'company',

      selectedSupplier: '',
      needSingle: false, // 是否单选

      companySupplierList: [], // 企业供应商
      companySupplierListFlatten: [], // 平铺企业供应商（去除第一级全部）
      sharedSupplierList: [], // 共享供应商
      sharedSupplierListFlatten: {}, // 平铺的共享供应商（去除第一级全部）

      selectedRows: [],

      // 选择的供应商分组对应的供应商列表
      dialogVisible: false,
      page: 1,
      size: 10,
      total: 0,
      selectedCompanyList: [],
      companySupplierOptions: [{ label: '供应商名称', prop: 'supplierName' }]
    }
  },

  computed: {
    supplierOptions() {
      const sharedSupplierList = cloneDeep(this.sharedSupplierList)
      if (this.sharedSupplierList.length) {
        sharedSupplierList.forEach(el => {
          el.disabled = true
        })
      }
      return [
        {
          name: '企业供应商',
          categoryId: categoryTypeDict.COMPANY.value,
          disabled: true,
          children: this.companySupplierList
        },
        {
          name: '共享供应商',
          categoryId: categoryTypeDict.SHARE.value,
          disabled: true,
          children: sharedSupplierList
        }
      ]
    },
    supplierTitleList() {
      return this.isAgency
        ? ['委托单位供应商库', '委托单位共享供应商库']
        : ['供应商库', '共享供应商库']
    }
  },

  watch: {
    filterSupplierName(val) {
      this.$refs.companySupplierGroup &&
        this.$refs.companySupplierGroup.filter(val)
      this.$refs.sharedSupplierGroup &&
        this.$refs.sharedSupplierGroup.filter(val)
    },

    selected: {
      handler: function(val) {
        if (val) {
          this.selectedRows = cloneDeep(this.normalizeIn(val)) || []
          this.selectedRows.forEach(el => {
            if (el.categoryId === 0) {
              el.name = el.name || '全部供应商'
            }
          })
          if (this.needSingle && this.selectedRows.length) {
            this.selectedSupplier = this.selectedRows[0].categoryId
          }
        }
      },
      immediate: true,
      deep: true
    },

    needSingle: {
      handler: function(val) {
        if (val) {
          this.getCategoriesTreeData()
          this.getSharedCategories()
        }
      },
      immediate: true
    },

    isSingle: {
      handler: function(val) {
        if (val) {
          this.getZjgjInquirySrm()
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 打开已选的供应商列表
     */
    async openSelectedSupplier() {
      try {
        const { data } = await getSelectedSupplierListApi({
          page: this.page,
          size: this.size,
          allScope: 1,
          categoryIds: this.needSingle
            ? this.selectedSupplier
            : this.selectedRows.map(el => el.categoryId).join(',')
        })
        this.dialogVisible = true
        this.selectedCompanyList = data.records || []
        this.total = data.total || 0
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 选择定向供应商库（灰度）
     */
    async getZjgjInquirySrm() {
      try {
        const { data } = await getZjgjInquirySrmApi()
        this.needSingle = data?.enable
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 更改级联选择器
     */
    changeSupplier(val) {
      const checkedNodes = this.$refs.cascader?.getCheckedNodes()
      if (!checkedNodes) return
      const selectedRows = [
        {
          categoryId: val,
          categoryType: checkedNodes[0]?.pathNodes[0]?.value,
          name: checkedNodes[0]?.label
        }
      ]
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(selectedRows))
      } else {
        this.$emit('change', selectedRows)
      }
    },

    /**
     * 打开弹窗
     */
    openDrawer() {
      if (this.isAgency && !this.purchaseCompanyId) {
        this.$message.warning('请选择委托项目')
        return false
      }
      if (this.isAgency && this.purchaseCompanyId && !this.isAllowUseSrm) {
        this.$message.warning('没有可定向公开的供应商分组，请更换方式后重试')
        return false
      }
      this.drawerVisible = true
      this.getCategoriesTreeData()
      this.getSharedCategories()
    },

    /**
     * 查询筛选后的供应商分组
     */
    filterNode(value, data) {
      if (!value) return true
      return data.name.includes(value)
    },

    /**
     * 确认关闭弹窗
     */
    handleDrawerClose() {
      this.drawerVisible = false
    },

    /**
     * 确认提交分组
     */
    handleConfirm() {
      const selectedCompanyNodes = this.$refs.companySupplierGroup
        .getCheckedNodes()
        .map(el => {
          el.categoryType = categoryTypeDict.COMPANY.value
          return el
        })
      const selectedSharedNodes = this.$refs.sharedSupplierGroup
        .getCheckedNodes()
        .map(el => {
          el.categoryType = categoryTypeDict.SHARE.value
          return el
        })
        .filter(el => !`${el.categoryId}`.includes('company'))
      this.selectedRows = [...selectedCompanyNodes, ...selectedSharedNodes]
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(this.selectedRows))
      } else {
        this.$emit('change', this.selectedRows)
      }
      this.handleDrawerClose()
    },

    /**
     * 点击节点，触发全选
     */
    clickNode(data, node) {
      // 当为最上面一个层级时候，手动添加全选功能
      if (data.parentId === null || data.parentId === undefined) {
        if (this.activeName === 'company') {
          if (node.checkedKeys.includes(data.categoryId)) {
            this.$refs.companySupplierGroup.setCheckedNodes(
              this.companySupplierListFlatten
            )
          } else {
            this.$refs.companySupplierGroup.setCheckedNodes([])
          }
        } else if (this.activeName === 'share') {
          const checkedTopNodes = node.checkedKeys.filter(el => {
            return `${el}`.includes('company')
          })
          const infoNodeIds = this.sharedSupplierListFlatten[
            data.categoryId
          ].map(el => el.categoryId)
          if (checkedTopNodes.includes(data.categoryId)) {
            this.$refs.sharedSupplierGroup.setCheckedKeys(
              new Set([...infoNodeIds, ...node.checkedKeys])
            )
          } else {
            this.$refs.sharedSupplierGroup.setCheckedKeys(
              difference(node.checkedKeys, infoNodeIds)
            )
          }
        }
      }
    },

    /**
     * tag删除选中项
     */
    handleClose(row) {
      const index = this.selectedRows.findIndex(
        el => el.categoryId === row.categoryId
      )
      this.selectedRows.splice(index, 1)
      if (isFunction(this.normalizeOut)) {
        this.$emit('change', this.normalizeOut(this.selectedRows))
      } else {
        this.$emit('change', this.selectedRows)
      }
    },

    /**
     * 获取供应商分组
     */
    async getCategoriesTreeData() {
      try {
        const { data } =
          this.isAllowUseSrm && this.isAgency
            ? await getSupplierLibSortApi({ companyId: this.purchaseCompanyId })
            : await getSupplierLibSortApi()
        this.companySupplierListFlatten = data || []
        this.companySupplierList = listTransformTree(data || [], 'categoryId')
        if (this.$refs.companySupplierGroup) {
          this.$refs.companySupplierGroup.setCheckedKeys(
            this.selectedRows.map(el => el.categoryId)
          )
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 获取分享的供应商分组
     */
    async getSharedCategories() {
      this.sharedSupplierListFlatten = {}
      try {
        const params = {
          companyId: this.purchaseCompanyId
        }
        const res =
          this.isAllowUseSrm && this.isAgency
            ? await getSupplierSharedCategoriesApi(params)
            : await getSupplierSharedCategoriesApi()
        const data = res.data || []
        const tempArray = []
        const selectedRowsIds = this.selectedRows.map(el => el.categoryId) || [] // 选中项的id值，因为后端不保存共享供应商组的根节点，需要特殊处理
        data.forEach(item => {
          const { sharedInfoList, ...other } = item
          this.sharedSupplierListFlatten[`company-${other.sharedCompanyId}`] = [
            { ...other, categoryId: `company-${other.sharedCompanyId}` },
            ...sharedInfoList
          ]

          const list = listTransformTree(
            (sharedInfoList || []).map(x => ({
              ...x,
              libraryType: shareLibraryTypeDict.GROUP.value,
              name: x.categoryName
            })),
            'categoryId'
          )
          tempArray.push({
            ...other,
            libraryType: shareLibraryTypeDict.COMPANY.value,
            categoryId: `company-${other.sharedCompanyId}`,
            name: other.sharedCompanyName,
            supplierCount: other.sharedSupplierCount,
            children: list
          })

          // 比较两个数组差值，若为空，则表示该根节点下面的子节点全部被选中，则自动选择根节点
          const rootCheckedArr = differenceBy(
            sharedInfoList,
            this.selectedRows,
            'categoryId'
          )
          if (rootCheckedArr.length === 0) {
            selectedRowsIds.push(`company-${other.sharedCompanyId}`)
          }
        })
        this.sharedSupplierList = tempArray
        if (this.$refs.sharedSupplierGroup) {
          this.$refs.sharedSupplierGroup.setCheckedKeys(selectedRowsIds)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
